import { withRouter, Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import MyIcon from "../MyIcon";
import "./index.scss";
import { alarmApi } from "@api/newApi";
const { SubMenu } = Menu;
import Icom from "./logo.png";
import smallIcom from "./small-logo.png";

const { LUXIANXUNJIANURL, LUXIAN_SCREEN_URL, LUXIANTENANTID } =
  window.globalConfig;
export default withRouter((props) => {
  const collapsed = props.collapsed;
  // 隐藏巡检任务(漏检)
  // console.log(props.userInfo.userResources[0].children)
  // const index = props.userInfo.userResources[0].children.findIndex(item => item.name === '巡检维修')
  // if (index !== -1) {
  //   props.userInfo.userResources[0].children[index].children = props.userInfo.userResources[0].children[index].children.filter(item => item.name !== '巡检任务(漏检)')
  // }
  const routersTurn = (values) => {
    let data =
      values &&
      values.map((v, i) => {
        let obj = {
          label: v.name,
          key: v.url || v.name,
          route: v.url,
          icon: (v.menuIcon && <MyIcon type={v.menuIcon} />) || null,
        };
        if (v.children && v.children.length > 0) {
          obj.children = routersTurn(v.children);
        }
        return obj;
      });
    return data;
  };
  const routersData =
    (props.userInfo.userResources &&
      routersTurn(
        (props.userInfo.userResources.length > 0 &&
          props.userInfo.userResources[0].children) ||
          []
      )) ||
    [];
  const routers = [
    {
      name: "厂站管理",
      route: "",
      icon: "iconicon_nav_changzhanguanli_nor",
      items: [
        {
          name: "GIS地图",
          route: "/stationManagement/GIS",
        },
        {
          name: "工艺流程",
          route: "/stationManagement/techProcess",
        },
        {
          name: "拖拽式工艺流程",
          route: "/stationManagement/settingProcessShow",
        },
        // {
        //   name: "数字孪生",
        //   route: "/stationManagement/bim",
        // }
      ],
    },
    {
      name: "故障告警",
      route: "",
      icon: "iconicon_nav_guzhanggaojing_act",
      children: [
        {
          name: "告警任务",
          route: "/warn/index",
        },
        {
          name: "告警设置",
          route: "/warn/setting",
        },
      ],
    },
    {
      name: "资产管理",
      route: "",
      icon: "iconicon_nav_zichanguanli_nor",
      children: [
        {
          name: "设备录入",
          route: "/assetsmana/addasset",
        },
        {
          name: "设备查询",
          route: "/assetsmana/searchlist",
        },
      ],
    },
    {
      name: "数据分析",
      route: "",
      icon: "iconicon_nav_shujufenxi_nor",
      children: [
        {
          name: "水量分析",
          route: "/analyse/dayreport",
        },
        {
          name: "水质分析",
          route: "/analyse/monthreport",
        },
        {
          name: "能耗分析",
          route: "/analyse/energyreport",
        },
        {
          name: "综合报表",
          route: "",
          children: [
            {
              name: "能耗报表",
              route: "/analyse/creport/ecreport",
            },
            {
              name: "水质报表",
              route: "/analyse/creport/wqreport",
            },
          ],
        },
      ],
    },
    // {
    //   name: "AI分析",
    //   route: "",
    //   icon: "iconAIyujing",
    //   children: [
    //     {
    //       name: "AI预警",
    //       route: "/analysis/earlywarning",
    //     }
    //   ],
    // },
    {
      name: "系统管理",
      route: "",
      icon: "iconshezhi",
      children: [
        {
          name: "工艺流程配置",
          route: "/systemSeting/settingProcess",
        },
        {
          name: "站点管理",
          route: "/systemSeting/station",
        },
        {
          name: "账户管理",
          route: "/systemSeting/user",
        },
        {
          name: "系统日志",
          route: "/systemSeting/sysmsg",
        },
        {
          name: "角色管理",
          route: "/systemSeting/role",
        },
        {
          name: "部门管理",
          route: "/systemSeting/department",
        },
      ],
    },
  ];

  if (props.userInfo.tenantId * 1 == LUXIANTENANTID * 1) {
    routers.push(
      {
        name: "巡检维修",
        route: "/inspection",
        icon: "iconicon_nav_xunjianyewu_nor",
        children: [
          {
            name: "巡检维修",
            route: LUXIANXUNJIANURL,
            isOpenNewPage: true,
          },
        ],
      },
      {
        name: "大屏",
        route: "/screen",
        icon: "iconshujudaping",
        children: [
          {
            name: "大屏",
            route: LUXIAN_SCREEN_URL,
            isOpenNewPage: true,
          },
        ],
      }
    );
  }

  const callback = (obj) => {
    if (obj.key.includes("http")) {
      window.open(obj.key, "_blank");
      return;
    }
    if (obj.key === "/screen") {
      //是否新开页面
      window.open("#" + obj.key, "_blank");
      return;
    }
    obj.key && props.history.push(obj.key);
  };

  // 获取告警与预警数量
  const [alarmCount, setalarmCount] = useState(0);
  const getAlarmCountFn = () => {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    alarmApi
      .selectAllAlarmNum(
        userInfo.stationIds ? userInfo.stationIds.split(",") : []
      )
      .then((res) => {
        if (res.status * 1 === 0) {
          let data = res.data.unreadAlarmNum + res.data.processingAlarmNum;
          data = data > 99 ? "99+" : data;
          setalarmCount(data);
        }
      });
  };
  useEffect(() => {
    getAlarmCountFn();
    let timer = setInterval(() => {
      getAlarmCountFn();
    }, 5 * 60 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  function getItem(label, key, icon, children, route) {
    return {
      key,
      icon,
      children,
      label,
      route,
    };
  }
  const renderMenus = (data) => {
    return (
      data &&
      data.map((item, index) => {
        return getItem(
          item.name,
          item.name,
          <MyIcon type={item.icon} />,
          item.children && renderMenus(item.children),
          item.route
        );
      })
    );
  };
  // [
  //   getItem('Navigation One', 'sub1', <MailOutlined />, [
  //     getItem('Item 1', 'g1', null, [getItem('Option 1', '1'), getItem('Option 2', '2')], 'group'),
  //     getItem('Item 2', 'g2', null, [getItem('Option 3', '3'), getItem('Option 4', '4')], 'group'),
  //   ]),
  //   getItem('Navigation Two', 'sub2', <AppstoreOutlined />, [
  //     getItem('Option 5', '5'),
  //     getItem('Option 6', '6'),
  //     getItem('Submenu', 'sub3', null, [getItem('Option 7', '7'), getItem('Option 8', '8')]),
  //   ]),
  //   getItem('Navigation Three', 'sub4', <SettingOutlined />, [
  //     getItem('Option 9', '9'),
  //     getItem('Option 10', '10'),
  //     getItem('Option 11', '11'),
  //     getItem('Option 12', '12'),
  //   ]),
  // ];
  /**
   * 递归遍历菜单树
   * @param data
   */
  const renderMenu = (data) => {
    return (
      data &&
      data.map((item, index) => {
        if (item.children && item.children.length) {
          return (
            <Menu.ItemGroup
              key={item.name}
              title={
                <span>
                  {item.icon && <MyIcon type={item.icon} />}
                  <span>{item.name}</span>
                </span>
              }
              onTitleClick={() => callback(item)}
            >
              {renderMenu(item.children)}
            </Menu.ItemGroup>
          );
        } else {
          if (item.name != "管理驾驶舱" && item.name != "拖拽式工艺流程") {
            return (
              <Menu.Item key={`${item.route}`} onClick={() => callback(item)}>
                {item.name}
                {item.name == "告警任务" && !collapsed && (
                  <span className="tip-Tag">{alarmCount}</span>
                )}
              </Menu.Item>
            );
          }
        }
      })
    );
  };

  // 获取导航默认展开项
  const [defaultOpenKeys, setdefaultOpenKeys] = useState("");
  // 默认选中的导航项
  const [selectedKeys, setselectedKeys] = useState("");
  useEffect(() => {
    let currpath = props.history.location.pathname;
    routersData.map((mm) => {
      let childs = [];
      let isThreeNavName = ""; //当前导航是否属于三级导航，它的父级名称
      mm.children &&
        mm.children.map((nn) => {
          if (nn.children && nn.children.length > 0) {
            nn.children.map((oo) => {
              childs.push(oo.key);
              if (oo.route.indexOf(currpath) > -1) {
                isThreeNavName = nn.name;
              }
            });
          }
          childs.push(nn.route);
        });

      if (childs.indexOf(currpath) > -1) {
        setselectedKeys(currpath);
        setdefaultOpenKeys([mm.key]);
      } else {
        childs.map((nn) => {
          if (nn != "" && currpath.indexOf(nn) > -1) {
            setdefaultOpenKeys([mm.key]);
            setselectedKeys(nn);
          }
        });
      }
    });
  }, [location.hash]);
  return (
    <>
      {
        <Menu
          mode="inline"
          selectedKeys={[selectedKeys]}
          openKeys={defaultOpenKeys}
          onOpenChange={(item) => {
            if (item[item.length - 1] == "综合报表") {
              setdefaultOpenKeys(item);
            } else {
              setdefaultOpenKeys([item[item.length - 1]]);
            }
          }}
          onClick={(item) => {
            setselectedKeys(item.key);
            callback(item);
          }}
          // theme={"dark"}
          className="main-menus"
          style={{ height: "calc(100% - 75px)", overflowY: "auto" }}
          items={routersData}
        ></Menu>
      }
    </>
  );
});
